export class GlobalMethods {
    static getWindowHeightWidth() {
        return {
            maxHeight: window.innerHeight,
            maxWidth: window.innerWidth,
            height: window.innerHeight,
            width: window.innerWidth
        }
    }
}
